import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-load-loop"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      y: "0",
      class: "icon-fi--no-fill icon-fi--filled"
    }, null, -1),
    _createElementVNode("g", {
      transform: "translate(0.895 0.838)",
      class: ""
    }, [
      _createElementVNode("path", {
        d: "M30.4,22.7c-0.3-0.1-0.7,0.1-0.8,0.4c0,0.1-1.9,6.8-8.4,6.8c-5.1,0-7.5-3.9-8.3-5.6l4.1,1.1c0.3,0.1,0.7-0.1,0.8-0.4\n\t\tc0.1-0.3-0.1-0.7-0.4-0.8L12,22.7c-0.2,0-0.3,0-0.5,0.1c-0.1,0.1-0.2,0.2-0.3,0.4l-1.4,5.3c-0.1,0.3,0.1,0.7,0.4,0.8\n\t\tc0.1,0,0.1,0,0.2,0c0.3,0,0.5-0.2,0.6-0.5l1-3.7c1.1,2.1,3.8,6.1,9.3,6.1c7.5,0,9.6-7.6,9.6-7.7C30.9,23.1,30.7,22.8,30.4,22.7z",
        class: ""
      }),
      _createElementVNode("path", {
        d: "M31.7,12.4c-0.3-0.1-0.7,0.1-0.8,0.5L30,16.6c-1.8-3.3-5.2-5.4-9-5.4c-7.3,0-9.5,7.1-9.5,7.1c-0.1,0.3,0.1,0.7,0.4,0.8\n\t\tc0.1,0,0.1,0,0.2,0c0.3,0,0.5-0.2,0.6-0.4c0.1-0.3,2-6.3,8.3-6.3c3.5,0,6.6,2,8,5.1l-4.1-1c-0.3-0.1-0.7,0.1-0.8,0.5\n\t\ts0.1,0.7,0.5,0.8l5.3,1.3c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.2,0.3-0.4l1.4-5.5C32.3,12.8,32.1,12.5,31.7,12.4z",
        class: ""
      })
    ], -1)
  ]), 16))
}
export default { render: render }